module.exports = function(){ /* empty */ };


//////////////////
// WEBPACK FOOTER
// ./~/.2.4.1@core-js/library/modules/_add-to-unscopables.js
// module id = 305
// module chunks = 3